import { render, staticRenderFns } from "./AreaFooter.vue?vue&type=template&id=28b98da8&"
import script from "./AreaFooter.vue?vue&type=script&lang=js&"
export * from "./AreaFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports